module.exports = __webpack_public_path__ + "img/tuiyuan.29f12816.png";